import { apiClient, getAuthHeaders } from './index';
import type { TokenState } from './types';

export enum RetrospectiveType {
    LATE_RECOGNITION = 'LATE_RECOGNITION', // 늦은 인지
    MISS = 'MISS', // 놓친 기회
    EARLY_EXIT = 'EARLY_EXIT', // 조기 매도
    LOSS = 'LOSS', // 손실
  }

export const retrospectiveApi = {
  /**
   * 손실 회고 API 호출
   * @param tokenAddress
   */
  async reportLoss(tokenAddress: string): Promise<void> {
    try {
      await apiClient.patch(
        `/fe-management-system/token-states/${tokenAddress}/retrospective/to-loss`,
        {},
        {
          headers: getAuthHeaders(),
        },
      );
    } catch (error) {
      console.error('❌ PATCH /fe-management-system/token-states/:tokenAddress/retrospective/to-loss 에러:', error);
      throw error;
    }
  },
  async fetchRetrospectiveTokens(archived?: string): Promise<TokenState[]> {
    try {
      const response = await apiClient.get(
        '/fe-management-system/token-states/queries/retrospective',
        {
          params: archived ? { archived } : undefined,
          headers: getAuthHeaders(),
        },
      );
      return response.data.data;
    } catch (error) {
      console.error('❌ GET /fe-management-system/token-states/queries/retrospective 에러:', error);
      throw error;
    }
  },
};
